import React, { useEffect, useState } from "react";
import dropdown from "../assets/dropdown.png";
import base from "../assets/base.png";
import polygon from "../assets/polygon.png";
import down from "../assets/swap.png";
import eth from "../assets/eth.png";
import gas from "../assets/gas.png";
import TokenModal from "./TokenDialog";
import SlippageSettings from "./SlippageSettings";
import { IoSettings } from "react-icons/io5";
import coin from "../assets/complere.png";
import {
    getErc20Contract,
    getFactoryContract,
    getRouterContract,
    getWalletBalanceContract,
    ThirdWebClient,
} from "../contexts/thirdWebClient";
import { allowance, approve, balanceOf } from "thirdweb/extensions/erc20";
import { routerAddress, WETHAddress } from "../contexts/config";
import {
    useActiveAccount,
    useActiveWalletChain,
    useSendTransaction,
} from "thirdweb/react";
import {
    prepareContractCall,
    readContract,
    sendTransaction as sendTx,
    waitForReceipt,
} from "thirdweb";
import { toast } from "react-toastify";
import { createPool } from "thirdweb/extensions/uniswap";
import { ethers } from "ethers";
import { getCurrencyMetadata } from "thirdweb/extensions/erc20";
import { getWalletBalance } from "thirdweb/wallets";
import { getPathAddress } from "../services/apiService";
import { list } from "../contexts/SelectTokenDATA";

const Swap = () => {
    const [open, setOpen] = useState(false);
    const [openBuy, setOpenBuy] = useState(false);
    const [selected, setSelected] = useState(list[0]); // Preselect ETH
    const [selectedBuy, setSelectedBuy] = useState(list[1]); // Preselect USDC
    const [loading, setLoading] = useState(false);
    const [balanceLoading, setBalanceLoading] = useState(false);
    const [checkData, setCheckData] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);
    const [slippage, setSlippage] = useState(() => {
        const saved = localStorage.getItem("perpx_slippage");
        return saved ? parseFloat(saved) : 1;
    });

    const add = useActiveAccount();
    const [address, setAddress] = useState("");
    const chain = useActiveWalletChain();
    useEffect(() => {
        if (add && add.address) {
            console.log("%c Line:41 🍅 add", "color:#7f2b82", add);
            setAddress(add.address);
        } else {
            // Wallet disconnected - clear all data
            setAddress("");
            setToken1Details({});
            setToken2Details({});
            setToken1value('');
            setToken2value('');
            setToken1valueDirect(0);
            setToken2valueDirect(0);
            setInsufficientBalance(false);
            setBalanceLoading(false);
        }
    }, [add, chain]);

    const [token1Details, setToken1Details] = useState({});
    const [token2Details, setToken2Details] = useState({});

    const [token1value, setToken1value] = useState('');
    const [token1valueDirect, setToken1valueDirect] = useState(0);
    const [token2value, setToken2value] = useState('');
    const [token2valueDirect, setToken2valueDirect] = useState(0);
    const [swapType, setSwapType] = useState(1);
    const [insufficientBalance, setInsufficientBalance] = useState(false);
    const [needsApproval, setNeedsApproval] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0); // Used to force refresh token details
    console.log("token2value", token1value, token2value)
    useEffect(() => {
        const getData = async () => {
            if (!address) {
                setBalanceLoading(false);
                return;
            }
            setBalanceLoading(true);
            try {
                if (
                    selected &&
                    selected !== "" &&
                    selected?.address &&
                    selectedBuy?.address != selected?.address &&
                    selected?.address !=
                    "0x0000000000000000000000000000000000000000"
                ) {
                    const contract = getErc20Contract(selected.address, chain);
                    let approvedAmount = await allowance({
                        contract,
                        owner: address,
                        spender: routerAddress,
                    });
                    let tokenBalance = await balanceOf({
                        contract,
                        address: address,
                    });
                    setToken1Details({
                        ...selected,
                        approvedBalance: Number(approvedAmount) * 1,
                        balance: Number(
                            ethers.formatUnits(
                                tokenBalance,
                                selected?.decimals,
                            ),
                        ) * 1,
                    });
                }
                if (
                    selected &&
                    selected !== "" &&
                    selectedBuy?.address != selected?.address &&
                    selected?.address ==
                    "0x0000000000000000000000000000000000000000"
                ) {
                    let tokenBalance = await getWalletBalanceContract(
                        address,
                        chain,
                    );
                    setToken1Details({
                        ...selected,
                        approvedBalance: Number(100000000000) * 1,
                        balance: Number(ethers.formatUnits(tokenBalance, 18)) * 1,
                    });
                }
                if (
                    selectedBuy &&
                    selectedBuy !== "" &&
                    selectedBuy?.address &&
                    selectedBuy?.address !=
                    "0x0000000000000000000000000000000000000000"
                ) {
                    const contract = getErc20Contract(selectedBuy.address, chain);
                    let approvedAmount = await allowance({
                        contract,
                        owner: address,
                        spender: routerAddress,
                    });
                    let tokenBalance = await balanceOf({
                        contract,
                        address: address,
                    });
                    setToken2Details({
                        ...selectedBuy,
                        approvedBalance: Number(approvedAmount) * 1,
                        balance: Number(
                            ethers.formatUnits(
                                tokenBalance,
                                selectedBuy?.decimals,
                            ),
                        ) * 1,
                    });
                }
                if (
                    selectedBuy &&
                    selectedBuy !== "" &&
                    selectedBuy?.address ==
                    "0x0000000000000000000000000000000000000000"
                ) {
                    let tokenBalance = await getWalletBalanceContract(
                        address,
                        chain,
                    );
                    setToken2Details({
                        ...selectedBuy,
                        approvedBalance: Number(100000000000) * 1,
                        balance: Number(ethers.formatUnits(tokenBalance, 18)) * 1,
                    });
                }
            } catch (error) {
                console.error("Error fetching balance:", error);
            } finally {
                setBalanceLoading(false);
            }
        };
        getData();
    }, [selected, selectedBuy, loading, refreshTrigger, address]);

    useEffect(() => {
        if (token1Details.address && token2Details.address) {
            fetchLpDetails();
        }
    }, [token1Details.address, token2Details.address]);

    // Reset insufficient balance when tokens change
    useEffect(() => {
        setInsufficientBalance(false);
        setToken1value('');
        setToken2value('');
    }, [selected, selectedBuy]);

    // Check if approval is needed based on swap amount
    useEffect(() => {
        // Skip for native ETH - no approval needed
        if (selected?.address === "0x0000000000000000000000000000000000000000") {
            setNeedsApproval(false);
            return;
        }

        // Check if swap amount exceeds allowance
        if (token1value > 0 && token1Details?.approvedBalance !== undefined) {
            try {
                const swapAmountWei = ethers.parseUnits(
                    String(token1value),
                    selected?.decimals || 18
                );
                setNeedsApproval(swapAmountWei > window.BigInt(token1Details.approvedBalance));
            } catch (error) {
                console.log("Error checking allowance:", error);
                setNeedsApproval(false);
            }
        } else {
            setNeedsApproval(false);
        }
    }, [token1value, token1Details?.approvedBalance, selected?.address, selected?.decimals]);

    // Calculate minimum output with slippage
    const calculateMinOutput = (expectedAmount, decimals) => {
        try {
            const slippageMultiplier = (100 - slippage) / 100;
            const minAmount = parseFloat(expectedAmount) * slippageMultiplier;
            return ethers.parseUnits(minAmount.toFixed(decimals), decimals);
        } catch (error) {
            console.log("Error calculating min output:", error);
            return "1"; // Fallback to 1
        }
    };

    // Parse error messages for user-friendly display
    const parseErrorMessage = (error) => {
        const message = error?.message || error?.reason || "Transaction failed";

        // Common error patterns and user-friendly messages
        if (message.includes("user rejected") || message.includes("User denied")) {
            return "Transaction was cancelled";
        }
        if (message.includes("insufficient funds")) {
            return "Insufficient funds for gas fees";
        }
        if (message.includes("INSUFFICIENT_OUTPUT_AMOUNT")) {
            return "Price moved too much. Try increasing slippage";
        }
        if (message.includes("EXPIRED")) {
            return "Transaction expired. Please try again";
        }
        if (message.includes("INSUFFICIENT_LIQUIDITY")) {
            return "Insufficient liquidity for this trade";
        }
        if (message.includes("TRANSFER_FROM_FAILED")) {
            return "Token transfer failed. Please check approval";
        }
        if (message.includes("execution reverted")) {
            // Try to extract the revert reason
            const revertMatch = message.match(/reason="([^"]+)"/);
            if (revertMatch) {
                return revertMatch[1];
            }
            return "Transaction reverted. Please try again";
        }

        // If message is too long, truncate it
        if (message.length > 100) {
            return message.substring(0, 100) + "...";
        }

        return message;
    };

    const approveTokenFun = async (tokenAddress) => {
        try {
            setLoading(true);
            const contract = getErc20Contract(tokenAddress, chain);
            // Use max uint256 for unlimited approval (standard practice)
            const transaction = approve({
                contract,
                spender: routerAddress,
                amountWei: window.BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"),
            });
            const { transactionHash } = await sendTx({ transaction, account: add });

            // Wait for transaction to be confirmed
            const receipt = await waitForReceipt({
                client: ThirdWebClient,
                chain,
                transactionHash,
            });

            if (receipt.status === "success") {
                toast.success("Token approved");
                // Trigger refresh of token details to get updated allowance
                setRefreshTrigger(prev => prev + 1);
            } else {
                toast.error("Approval failed");
            }
            setLoading(false);
        } catch (error) {
            const errorMessage = parseErrorMessage(error);
            toast.error(errorMessage);
            setLoading(false);
            console.log("%c Line:111 🍫 error", "color:#ed9ec7", error);
        }
    };

    const [price, setPrice] = useState(0);
    const [lpAddress, setLpAddress] = useState(false);
    const [token1LpBalance, setToken1LpBalance] = useState(0);
    const [token2LpBalance, setToken2LpBalance] = useState(0);

    const fetchLpDetails = async () => {
        try {
            const routerContract = await getRouterContract(chain);
            const factoryContract = await getFactoryContract(chain);

            let pairAddress = await readContract({
                contract: factoryContract,
                method: "function getPair(address, address) view returns (address)",
                params: [
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                ],
            });

            if (pairAddress != "0x0000000000000000000000000000000000000000") {
                // setLpAddress(true);
                setLpAddress([token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token1Details?.address,
                token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token2Details?.address]);

                const Token0contract = getErc20Contract(
                    token1Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token1Details?.address,
                    chain,
                );
                let tokenOUserBalance = await balanceOf({
                    contract: Token0contract,
                    address: pairAddress,
                });
                setToken1LpBalance(tokenOUserBalance);

                const Token1contract = getErc20Contract(
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address,
                    chain,
                );

                let token1UserBalance = await balanceOf({
                    contract: Token1contract,
                    address: pairAddress,
                });
                setToken2LpBalance(token1UserBalance);

                let tokenPrice = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits("1", selected?.decimals),
                        tokenOUserBalance,
                        token1UserBalance,
                    ],
                });

                setPrice(
                    Number(
                        ethers.formatUnits(tokenPrice, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            } else {
                const getPath = await getPathAddress(token1Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                    ? WETHAddress
                    : token1Details?.address,
                    token2Details?.address ==
                        "0x0000000000000000000000000000000000000000"
                        ? WETHAddress
                        : token2Details?.address)

                console.log("%c Line:277 🥃 getPath", "color:#f5ce50", getPath);

                if (getPath.data) {
                    let pairAddress = await readContract({
                        contract: routerContract,
                        method: "function getAmountsOut(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                        params: [ethers.parseUnits("1", selected?.decimals), getPath.data]
                    });

                    setPrice(
                        Number(
                            ethers.formatUnits(pairAddress[pairAddress.length - 1], selectedBuy?.decimals),
                        ).toFixed(5),
                    );


                    setLpAddress(getPath.data);
                } else {
                    setLpAddress(false)
                }
            }
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const fetchPriceDetails = async (value) => {
        try {
            // If value is empty or 0, don't proceed with fetch
            const numValue = parseFloat(value);
            if (!value || value === '' || isNaN(numValue) || numValue === 0 || numValue <= 0) {
                return;
            }

            // Check if value exceeds balance
            if (!isNaN(numValue) && numValue > 0 && token1Details?.balance !== undefined) {
                setInsufficientBalance(numValue > token1Details.balance);
            } else {
                setInsufficientBalance(false);
            }

            const routerContract = await getRouterContract(chain);
            if (lpAddress && lpAddress.length > 1) {

                let pairAddress = await readContract({
                    contract: routerContract,
                    method: "function getAmountsOut(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                    params: [ethers.parseUnits(value, selected?.decimals), lpAddress]
                });
                setToken2value(
                    Number(
                        ethers.formatUnits(pairAddress[pairAddress.length - 1], selectedBuy?.decimals),
                    ).toFixed(5),
                );
                setToken2valueDirect(pairAddress[pairAddress.length - 1])

            } else {

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits(value, selected?.decimals),
                        token1LpBalance,
                        token2LpBalance,
                    ],
                });

                setToken2value(
                    Number(
                        ethers.formatUnits(token0Price, selectedBuy?.decimals),
                    ).toFixed(5),
                );
            }
            setSwapType(1);
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    // Recalculate price when lpAddress becomes available and a value is already entered
    useEffect(() => {
        if (lpAddress && token1value && parseFloat(token1value) > 0) {
            fetchPriceDetails(token1value);
        }
    }, [lpAddress]);

    const fetchPrice2Details = async (value) => {
        try {
            // If value is empty or 0, don't proceed with fetch
            const numValue = parseFloat(value);
            if (!value || value === '' || isNaN(numValue) || numValue === 0 || numValue <= 0) {
                return;
            }

            const routerContract = await getRouterContract(chain);
            if (lpAddress && lpAddress.length > 1) {

                let pairAddress = await readContract({
                    contract: routerContract,
                    method: "function getAmountsIn(uint256 amountIn, address[] path) view returns (uint256[] amounts)",
                    params: [ethers.parseUnits(value, selectedBuy?.decimals), lpAddress]
                });

                const requiredToken1Amount = Number(
                    ethers.formatUnits(pairAddress[0], selected?.decimals),
                ).toFixed(5);

                setToken1value(requiredToken1Amount);
                setToken1valueDirect(pairAddress[0]);

                // Check if required amount exceeds balance
                if (token1Details?.balance !== undefined) {
                    setInsufficientBalance(parseFloat(requiredToken1Amount) > token1Details.balance);
                }
            } else {

                let token0Price = await readContract({
                    contract: routerContract,
                    method: "function quote(uint256 amountA, uint256 reserveA, uint256 reserveB) pure returns (uint256 amountB)",
                    params: [
                        ethers.parseUnits(value, selectedBuy?.decimals),
                        token2LpBalance,
                        token1LpBalance,
                    ],
                });

                const requiredToken1Amount = Number(
                    ethers.formatUnits(token0Price, selected?.decimals),
                ).toFixed(5);

                setToken1value(requiredToken1Amount);

                // Check if required amount exceeds balance
                if (token1Details?.balance !== undefined) {
                    setInsufficientBalance(parseFloat(requiredToken1Amount) > token1Details.balance);
                }
            }
            setSwapType(2);
        } catch (error) {
            console.log("%c Line:47 🍉 error", "color:#42b983", error);
        }
    };

    const handleSwapTokens = () => {
        // Swap the selected tokens
        const tempSelected = selected;
        setSelected(selectedBuy);
        setSelectedBuy(tempSelected);

        // Swap the token details
        const tempDetails = token1Details;
        setToken1Details(token2Details);
        setToken2Details(tempDetails);

        // Swap the values
        const tempValue = token1value;
        setToken1value(token2value);
        setToken2value(tempValue);

        const tempValueDirect = token1valueDirect;
        setToken1valueDirect(token2valueDirect);
        setToken2valueDirect(tempValueDirect);

        // Reset insufficient balance warning
        setInsufficientBalance(false);
    };

    // Handle "from" token selection - prevent same token
    const handleFromTokenSelect = (token) => {
        if (token.address === selectedBuy.address) {
            // Swap: set old "from" as new "to"
            setSelectedBuy(selected);
        }
        setSelected(token);
    };

    // Handle "to" token selection - prevent same token
    const handleToTokenSelect = (token) => {
        if (token.address === selected.address) {
            // Swap: set old "to" as new "from"
            setSelected(selectedBuy);
        }
        setSelectedBuy(token);
    };

    const swapToken = async () => {
        try {
            const contract = getRouterContract(chain);

            let token1amount = ethers.parseUnits(
                token1value,
                token1Details?.decimals,
            );

            let token2amount = ethers.parseUnits(
                token2value,
                token2Details?.decimals,
            );

            let transaction;
            if (swapType == 1) {
                if (
                    token1Details?.address ==
                    "0x0000000000000000000000000000000000000000" ||
                    token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                ) {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapExactTokensForETH(uint256 amountIn, uint256 amountOutMin, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [
                            token1amount,
                            calculateMinOutput(token2value, token2Details?.decimals),
                            lpAddress,
                            // [
                            //     token1Details?.address ==
                            //         "0x0000000000000000000000000000000000000000"
                            //         ? WETHAddress
                            //         : token1Details?.address,
                            //     token2Details?.address ==
                            //         "0x0000000000000000000000000000000000000000"
                            //         ? WETHAddress
                            //         : token2Details?.address,
                            // ],
                            address,
                            Math.floor(new Date().getTime() / 1000) + 900,
                        ],
                        value:
                            token1Details?.address ==
                                "0x0000000000000000000000000000000000000000"
                                ? token1amount
                                : 0,
                    });
                } else {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapExactTokensForTokens(uint256 amountIn, uint256 amountOutMin, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [
                            token1amount,
                            calculateMinOutput(token2value, token2Details?.decimals),
                            lpAddress,
                            // [token1Details?.address, token2Details?.address],
                            address,
                            Math.floor(new Date().getTime() / 1000) + 900,
                        ],
                    });
                }
            } else {
                if (
                    token1Details?.address ==
                    "0x0000000000000000000000000000000000000000" ||
                    token2Details?.address ==
                    "0x0000000000000000000000000000000000000000"
                ) {

                    transaction = prepareContractCall({
                        contract,
                        method: "function swapETHForExactTokens(uint256 amountOut, address[] path, address to, uint256 deadline) payable returns (uint256[] amounts)", //"function swapETHForExactTokens(uint256 amountOut, uint256 amountInMax, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [
                            token2amount,
                            // "1",
                            lpAddress,

                            // [
                            //     token1Details?.address ==
                            //         "0x0000000000000000000000000000000000000000"
                            //         ? WETHAddress
                            //         : token1Details?.address,
                            //     token2Details?.address ==
                            //         "0x0000000000000000000000000000000000000000"
                            //         ? WETHAddress
                            //         : token2Details?.address,
                            // ],
                            address,
                            Math.floor(new Date().getTime() / 1000) + 900,
                        ],
                        value:
                            token1valueDirect,
                    });
                    console.log("%c Line:503 🍅 transaction", "color:#b03734", transaction);

                } else {
                    transaction = prepareContractCall({
                        contract,
                        method: "function swapTokensForExactTokens(uint256 amountOut, uint256 amountInMax, address[] path, address to, uint256 deadline) returns (uint256[] amounts)",
                        params: [
                            token2amount,
                            calculateMinOutput(token1value, token1Details?.decimals),
                            lpAddress,
                            // [token1Details?.address, token2Details?.address],
                            address,
                            Math.floor(new Date().getTime() / 1000) + 900,
                        ],
                    });
                }
            }
            setLoading(true);
            const { transactionHash } = await sendTx({ transaction, account: add });

            // Wait for transaction to be confirmed
            const receipt = await waitForReceipt({
                client: ThirdWebClient,
                chain,
                transactionHash,
            });

            if (receipt.status === "success") {
                toast.success("Token Swap Successful!");
                // Reset input values after successful swap
                setToken1value(0);
                setToken2value(0);
                setToken1valueDirect(0);
                setToken2valueDirect(0);
            } else {
                toast.error("Swap transaction failed");
            }

            setLoading(false);
        } catch (error) {
            const errorMessage = parseErrorMessage(error);
            toast.error(errorMessage);
            setLoading(false);
            console.log("%c Line:166 🍕 error", "color:#f5ce50", error);
        }
    };

    return (
        <div className="max-w-[524px] mx-3 sm:mx-auto mt-10 flex gap-2 items-center flex-col p-6 rounded-2xl bg-perpx-dark-tertiary/60 backdrop-blur-xl border border-perpx-cyan/15 shadow-[0_8px_32px_rgba(0,0,0,0.4)] shadow-perpx-cyan/5">
            {/* Settings Icon */}
            <div className="w-full flex justify-end mb-2">
                <IoSettings
                    className="text-perpx-cyan/70 cursor-pointer hover:text-perpx-cyan hover:rotate-45 transition-all duration-300 size-[24px]"
                    onClick={() => setSettingsOpen(true)}
                    title="Slippage Settings"
                />
            </div>
            <div className="rounded-2xl overflow-hidden border w-full border-perpx-cyan/10 shadow-[0_2px_12px_rgba(0,0,0,0.2)]">
                <div className="bg-perpx-dark-secondary/60 text-perpx-text-primary flex justify-between text-[14px] sm:text-[16px] font-normal px-6 py-3 border-b border-perpx-cyan/10">
                    <h6 className="text-perpx-text-primary/70">Sell</h6>
                    {address && (
                        <p className="flex items-center">
                            Balance:
                            {balanceLoading ? (
                                <span className="ml-1 inline-block h-[16px] w-[60px] animate-pulse rounded bg-perpx-cyan/20"></span>
                            ) : (
                                <b className="text-perpx-cyan ml-1">
                                    {token1Details?.balance
                                        ? token1Details.balance.toFixed(4)
                                        : '0.0000'}
                                </b>
                            )}
                        </p>
                    )}
                </div>
                <div className="bg-perpx-dark/80 text-perpx-text-primary flex items-center justify-between text-[14px] sm:text-[16px] font-normal px-6 py-4">
                    <div className="text-left">
                        <input
                            className="text-[30px] sm:text-[38px] font-semibold text-perpx-cyan disabled:opacity-50 disabled:cursor-not-allowed"
                            style={{ width: "80%", background: 'transparent', outline: 'none' }}
                            type="text"
                            inputMode="decimal"
                            value={token1value}
                            placeholder="0"
                            disabled={!address}
                            onChange={(e) => {
                                let value = e.target.value;

                                // Only allow digits and one decimal point
                                if (!/^\d*\.?\d*$/.test(value)) return;

                                // Remove leading zeros (but keep "0." for decimals)
                                if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
                                    value = value.replace(/^0+/, '') || '';
                                }

                                if (value === '') {
                                    setToken1value('');
                                    setToken2value('');
                                    setToken2valueDirect(0);
                                    setInsufficientBalance(false);
                                    return;
                                }

                                const numValue = parseFloat(value);
                                setToken1value(value);
                                if (!isNaN(numValue) && numValue > 0) {
                                    fetchPriceDetails(value);
                                } else {
                                    setToken2value('');
                                    setToken2valueDirect(0);
                                    setInsufficientBalance(false);
                                }
                            }}
                        />
                        {/* <p className="text-[12px] sm:text-[14px] font-semibold text-[#3C486B] mt-1">
                            $3,380.62{" "}
                        </p> */}
                    </div>
                    <div
                        onClick={() => setOpen(!open)}
                        style={{ width: "70%" }}
                        className="flex items-center justify-center gap-2 sm:gap-3 bg-perpx-dark-secondary/80 rounded-full border border-perpx-cyan/20 hover:border-perpx-cyan/40 hover:bg-perpx-dark-secondary px-3 py-[6px] cursor-pointer transition-all duration-200 shadow-sm"
                    >
                        {selected && selected?.symbol ? (
                            <>
                                {selected?.emoji ? (
                                    <span className="text-[18px] sm:text-[22px]">{selected.emoji}</span>
                                ) : selected?.img ? (
                                    <img
                                        src={selected.img}
                                        alt={selected.symbol}
                                        className="size-[20px] sm:size-[26px] rounded-full"
                                    />
                                ) : null}
                                <h5 className="font-semibold text-[18px] sm:text-[22px] text-perpx-cyan">
                                    {selected?.symbol}
                                </h5>
                                <img
                                    src={dropdown}
                                    alt=""
                                    className="size-[18px] sm:size-[20px]"
                                />
                            </>
                        ) : (
                            <>
                                <h5 className="font-semibold text-[18px] sm:text-[16px] text-perpx-text-secondary">
                                    Select Token
                                </h5>
                                <img
                                    src={dropdown}
                                    alt=""
                                    className="size-[18px] sm:size-[20px]"
                                />
                            </>
                        )}
                        {/* <img
              src={
                selected === "ETH" ? eth : selected === "BASE" ? base : polygon
              }
              alt=""
              className="size-[20px] sm:size-[26px] rounded-full"
            />
            <h5 className="font-semibold text-[18px] sm:text-[22px] text-[#102C57]">
              {selected}
            </h5>
            <img src={dropdown} alt="" className="size-[18px] sm:size-[20px]" /> */}
                    </div>
                </div>
            </div>
            <img
                src={down}
                className="my-[-21px] z-50 h-[44px] w-[44px] bg-white p-2 rounded-full cursor-pointer hover:scale-110 hover:shadow-[0_0_16px_rgba(255,255,255,0.3)] transition-all duration-300 shadow-lg"
                onClick={handleSwapTokens}
                alt="Swap tokens"
            />
            <div className="rounded-2xl overflow-hidden border w-full border-perpx-cyan/10 shadow-[0_2px_12px_rgba(0,0,0,0.2)]">
                <div className="bg-perpx-dark/80 text-perpx-text-primary flex items-center justify-between text-[16px] font-normal px-6 py-4 border-b border-perpx-cyan/10">
                    <div className="text-left">
                        <input
                            className="text-[30px] sm:text-[38px] font-semibold text-perpx-cyan disabled:opacity-50 disabled:cursor-not-allowed"
                            style={{ width: "80%", background: 'transparent', outline: 'none' }}
                            type="text"
                            inputMode="decimal"
                            value={token2value}
                            placeholder="0"
                            disabled={!address}
                            onChange={(e) => {
                                let value = e.target.value;

                                // Only allow digits and one decimal point
                                if (!/^\d*\.?\d*$/.test(value)) return;

                                // Remove leading zeros (but keep "0." for decimals)
                                if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
                                    value = value.replace(/^0+/, '') || '';
                                }

                                if (value === '') {
                                    setToken2value('');
                                    setToken1value('');
                                    setToken1valueDirect(0);
                                    setInsufficientBalance(false);
                                    return;
                                }

                                const numValue = parseFloat(value);
                                setToken2value(value);
                                if (!isNaN(numValue) && numValue > 0) {
                                    fetchPrice2Details(value);
                                } else {
                                    setToken1value('');
                                    setToken1valueDirect(0);
                                    setInsufficientBalance(false);
                                }
                            }}
                        />
                        {/* <p className="text-[12px] sm:text-[14px] font-semibold text-[#3C486B] mt-1">
                            $3,380.62{" "}
                        </p> */}
                    </div>
                    <div
                        onClick={() => setOpenBuy(!openBuy)}
                        style={{ width: "70%" }}
                        className="flex items-center justify-center gap-2 sm:gap-3 bg-perpx-dark-secondary/80 rounded-full border border-perpx-cyan/20 hover:border-perpx-cyan/40 hover:bg-perpx-dark-secondary px-3 py-[6px] cursor-pointer transition-all duration-200 shadow-sm"
                    >
                        {selectedBuy && selectedBuy?.symbol ? (
                            <>
                                {selectedBuy?.emoji ? (
                                    <span className="text-[18px] sm:text-[22px]">{selectedBuy.emoji}</span>
                                ) : selectedBuy?.img ? (
                                    <img
                                        src={selectedBuy.img}
                                        alt={selectedBuy.symbol}
                                        className="size-[20px] sm:size-[26px] rounded-full"
                                    />
                                ) : null}
                                <h5 className="font-semibold text-[18px] sm:text-[22px] text-perpx-cyan">
                                    {selectedBuy?.symbol}
                                </h5>
                                <img
                                    src={dropdown}
                                    alt=""
                                    className="size-[18px] sm:size-[20px]"
                                />
                            </>
                        ) : (
                            <>
                                <h5 className="font-semibold text-[16px] sm:text-[16px] text-perpx-text-secondary">
                                    Select Token
                                </h5>
                                <img
                                    src={dropdown}
                                    alt=""
                                    className="size-[18px] sm:size-[20px]"
                                />
                            </>
                        )}
                        {/* <img
              src={
                selectedBuy === "ETH"
                  ? eth
                  : selectedBuy === "BASE"
                  ? base
                  : polygon
              }
              alt=""
              className="size-[20px] sm:size-[26px] rounded-full"
            />
            <h5 className="font-semibold text-[18px] sm:text-[22px] text-[#102C57]">
              {selectedBuy}
            </h5>
            <img src={dropdown} alt="" className="size-[18px] sm:size-[20px]" /> */}
                    </div>
                </div>
                <div className="bg-perpx-dark-secondary/60 text-perpx-text-primary flex justify-between text-[14px] sm:text-[16px] font-normal px-6 py-3">
                    <h6 className="text-perpx-text-primary/70">Buy</h6>
                    {address && (
                        <p className="flex items-center">
                            Balance:
                            {balanceLoading ? (
                                <span className="ml-1 inline-block h-[16px] w-[60px] animate-pulse rounded bg-perpx-cyan/20"></span>
                            ) : (
                                <b className="text-perpx-cyan ml-1">
                                    {token2Details?.balance
                                        ? token2Details.balance.toFixed(4)
                                        : '0.0000'}
                                </b>
                            )}
                        </p>
                    )}
                </div>
            </div>

            {/* Insufficient Balance Warning */}
            {insufficientBalance && token1value > 0 && (
                <div className="w-full mt-3 p-3 rounded-lg bg-red-500/10 border border-red-500/30">
                    <p className="text-red-400 text-[14px]">
                        Insufficient balance. You need {token1value} {selected?.symbol} but only have {token1Details?.balance?.toFixed(4)} {selected?.symbol}
                    </p>
                </div>
            )}

            {/* No Liquidity Pair Warning */}
            {!lpAddress && address && selected?.symbol && selectedBuy?.symbol && (
                <div className="w-full mt-3 p-3 rounded-lg bg-yellow-500/10 border border-yellow-500/30">
                    <p className="text-yellow-400 text-[14px]">
                        No liquidity pool found for {selected?.symbol}/{selectedBuy?.symbol}. This pair is not available for swapping.
                    </p>
                </div>
            )}

            {loading ? (
                <button
                    className="bg-gradient-to-r from-perpx-cyan to-perpx-cyan/80 mt-3 w-full rounded-2xl py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold shadow-[0_4px_16px_rgba(0,255,255,0.2)] transition-all"
                    disabled
                >
                    Loading..
                </button>
            ) : needsApproval && !insufficientBalance && token1value > 0 ? (
                <button
                    className="bg-gradient-to-r from-perpx-cyan to-perpx-cyan/80 mt-3 w-full rounded-2xl py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold shadow-[0_4px_16px_rgba(0,255,255,0.2)] hover:shadow-[0_4px_24px_rgba(0,255,255,0.35)] hover:scale-[1.01] active:scale-[0.99] transition-all duration-200"
                    onClick={() => approveTokenFun(selected.address)}
                    disabled={!address}
                >
                    Approve {selected?.symbol}
                </button>
            ) : (
                <button
                    className="bg-gradient-to-r from-perpx-cyan to-perpx-cyan/80 mt-3 w-full rounded-2xl py-[16px] px-[4px] text-perpx-dark text-[18px] font-semibold shadow-[0_4px_16px_rgba(0,255,255,0.2)] hover:shadow-[0_4px_24px_rgba(0,255,255,0.35)] hover:scale-[1.01] active:scale-[0.99] transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:shadow-none"
                    onClick={swapToken}
                    disabled={!address || !lpAddress || insufficientBalance || !token1value || parseFloat(token1value) <= 0 || !token2value || parseFloat(token2value) <= 0}
                >
                    {!address ? "Please Connect Your Wallet" : !lpAddress ? "No Liquidity Available" : insufficientBalance ? "Insufficient Balance" : (!token1value || parseFloat(token1value) <= 0 || !token2value || parseFloat(token2value) <= 0) ? "Enter an amount" : "Swap Now"}
                </button>
            )}
            <div className="bg-perpx-dark-secondary/40 w-full text-perpx-text-primary flex justify-between text-[14px] sm:text-[16px] rounded-xl font-medium px-4 py-3 border border-perpx-cyan/10">
                {lpAddress ?
                    <h6>
                        1 {token1Details.symbol} = {price} {token2Details?.symbol}{" "}
                        {/* ($0.999) */}
                    </h6> :
                    token1Details.symbol && token2Details.symbol &&
                    <h6>
                        Pair not found
                    </h6>
                }
                {/* <div className="flex justify-center items-center gap-2">
                    <img src={gas} />
                    <b className="text-[16px] sm:text-[18px] font-medium">
                        $2.00
                    </b>
                </div> */}
            </div>
            <TokenModal open={open} setOpen={setOpen} onClick={handleFromTokenSelect} />
            <TokenModal
                open={openBuy}
                setOpen={setOpenBuy}
                onClick={handleToTokenSelect}
            />
            <SlippageSettings
                open={settingsOpen}
                setOpen={setSettingsOpen}
                slippage={slippage}
                setSlippage={setSlippage}
            />
        </div>
    );
};

export default Swap;
